'use client';

import * as React from 'react';

import type { OrganizationLimitsDto } from '~/types/dtos/organization-limits-dto';

const OrganizationLimitsContext = React.createContext<
  OrganizationLimitsDto | null | undefined
>(undefined);

export type OrganizationLimitsProviderProps = React.PropsWithChildren<{
  limits: OrganizationLimitsDto | null;
}>;

export function OrganizationLimitsProvider({
  limits,
  children
}: OrganizationLimitsProviderProps): React.JSX.Element {
  return (
    <OrganizationLimitsContext.Provider value={limits}>
      {children}
    </OrganizationLimitsContext.Provider>
  );
}

export function useOrganizationLimits(): OrganizationLimitsDto | null {
  const context = React.useContext(OrganizationLimitsContext);

  if (context === undefined) {
    throw new Error(
      'useOrganizationLimits must be used within an OrganizationLimitsProvider'
    );
  }

  return context;
}
